import React, { Fragment, useEffect, useState } from 'react';
import { withStore } from 'contexts/store-context';
import { withToast } from 'contexts/toast-context';
import PhotoForm from 'components/photo/photo-form';
import PhotoList from 'components/photo/photo-list';
import PaginationWrapper from 'components/bootstrap/pagination-wrapper';
import { SectionBlock, SectionTitle, SectionBody, SectionFooter } from 'components/blocks/section-blocks';
import { NextButton } from 'components/bootstrap/button-wrapper';
import { Button, Modal } from 'reactstrap';
import { isEmpty, timeout } from 'utils/helpers';

const PhotoSection = (props) => {
  const { store, toast } = props;
  const [ photos, setPhotos ] = useState([]);
  const [ modal, toggleModal ] = useState(false);
  const [ page, setPage ] = useState(0);
  const [ pageSize, setPageSize ] = useState(10);
  const [ loading, setLoading ] = useState(false);


  // Hooks
  useEffect(() => {
    fetchData();
  }, [page]);



  // Tasks
  const fetchData = async () => {
    try {
      setLoading(true);
      let model = await store.query('photo', params());
      setPhotos(model);
    } catch(e) {
      toast.showError(e);
    } finally {
      setLoading(false);
    }
  }

  const params = () => {
    let params = {};
    if (page) params.page = page;
    if (pageSize) params.pageSize = pageSize;
    return params;
  }

  const refreshData = () => {
    toggleModal(!modal);
    fetchData();
  }


  // Render
  return (
    <Fragment>
      <Modal isOpen={modal}>
        <PhotoForm modal={modal} toggleModal={() => toggleModal(!modal)} nextAction={refreshData} />
      </Modal>
      <SectionBlock>
        <SectionTitle title='Photos' className='flex-between'>
          <NextButton title='Add Photo' onClick={() => toggleModal(!modal)} />
        </SectionTitle>
        <SectionBody className='md'>
          <PhotoList
            type='grid'
            photos={photos}
            loading={loading}
            nextAction={() => fetchData()}
          />
        </SectionBody>
        <SectionFooter>
          <PaginationWrapper meta={photos.meta} setPage={p => setPage(p)} />
        </SectionFooter>
      </SectionBlock>
    </Fragment>
  );
}


export default withStore(withToast(PhotoSection));
